const name = 'circle-g';


const contents = `
<circle cx="31" cy="41" r="29"/>
<path d="M31 55.5c-2.375 0-4.378-.373-6.007-1.119-1.63-.745-2.955-1.767-3.977-3.065-1.022-1.298-1.754-2.831-2.196-4.599-.442-1.767-.663-3.673-.663-5.717 0-1.989.221-3.867.663-5.634.442-1.768 1.174-3.315 2.196-4.64 1.022-1.326 2.347-2.362 3.977-3.107 1.63-.746 3.632-1.119 6.007-1.119 3.204 0 6.38.718 9.529 2.154l-1.078 4.309c-2.927-1.215-5.551-1.823-7.871-1.823-2.817 0-4.82.898-6.007 2.693-1.188 1.795-1.782 4.184-1.782 7.167 0 2.983.608 5.372 1.823 7.167 1.216 1.795 3.038 2.693 5.469 2.693.552 0 1.132-.028 1.74-.083.607-.055 1.298-.22 2.071-.497v-9.197h5.635v12.263C37.38 54.782 34.204 55.5 31 55.5z" fill="#FFF"/>
`;


/** @type {import ('./types').CharacterIcon} */
const icon = {
  name,
  contents,
  iconCharacter: 'G',
};

export default icon;
